import { useEffect } from "react";
import "./App.css";
import { Ultra24HeroOverviewBlock } from "./sections/Ultra24HeroOverviewBlock";
import { Ultra24OverviewSection } from "./sections/Ultra24OverviewSection";

import { Ultra24GoalsWhyBlock } from "./sections/Ultra24GoalsWhyBlock";
import { Ultra24CategorySection } from "./sections/Ultra24CategorySection";
import { Ultra24GallerySection } from "./sections/Ultra24GallerySection";
import { Ultra24RaceTableSection } from "./sections/Ultra24RaceTableSection";

const Beranda = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Ultra24HeroOverviewBlock />
      <Ultra24OverviewSection />
      <Ultra24CategorySection />
      <Ultra24GallerySection />

      <Ultra24GoalsWhyBlock />

      <Ultra24RaceTableSection />
    </>
  );


};

export default Beranda;
